<div class="card-wrapper">
  <div class="card-box" [class.card-has-company]="hasSampleCompany" [@flipState]="flip">
    <div class="card-box-side card-box-front" [ngClass]="{ selected: selected }">
      <span (click)="toggleFlip($event)" class="icon-i-info"></span>
      <img [src]="card.icon ? card.icon : card.img" class="card-icon" />
      <div class="card-box-content">
        <p>{{ card.name }}</p>
        <span *ngIf="showSampleCompanies && hasSampleCompany" title="{{ 'general.example' | translate }} {{ card.sample_companies }}"
          >{{ 'general.example' | translate }} {{ card.sample_companies }}</span
        >
      </div>
    </div>
    <div class="card-box-side card-box-back" [ngClass]="{ selected: selected }" (click)="toggleFlip($event)">
      <span class="icon-i-close-circle"></span>
      <p [innerHtml]="card.desc"></p>
    </div>
  </div>
</div>
